module.exports = __webpack_public_path__ + "static/img/role.1c013a0.png";


//////////////////
// WEBPACK FOOTER
// ./static/en/img/role3/ch/role.png
// module id = 8YFe
// module chunks = 7